import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getEnabledLocales,
  getLocale,
  parsePath,
  localizePath,
  DEFAULT_LOCALE,
  STORAGE_KEY,
} from "@/i18n/helpers";

// Central language state/actions used by the switcher, header, footer, etc.
export default function useLanguage() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const locales = getEnabledLocales();
  const current = getLocale(i18n.language) || getLocale(DEFAULT_LOCALE);
  const { page } = parsePath(location.pathname);

  const selectLocale = (code) => {
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (e) {
      /* ignore */
    }
    navigate(localizePath(page, code));
  };

  return { locales, current, page, selectLocale };
}
